import { Component, ChangeDetectionStrategy, inject, input, output, OnInit, model } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@cue/ui';
import {
  cueArrowFullRight,
  cueNavigationCircle,
  cueWheelchair,
  cueClose,
  IconComponent,
  cueElevator,
} from '@cue/ui/icons';
import { FindPathResponseV2 } from '@cue/navigation-services';
import { LocalizedStringPipe } from '@cue/utilities';
import { translation } from '@cue/translations';
import { InstructionItem, ResourcePoiIdentificationCrate } from '@cue/data';
import { NAVIGATION_SETTINGS } from '@cue/navigation-settings';
import { DirectionsItemRenewComponent } from '../direction-item-renew/directions-item-renew.component';
import { NavigationBarDataV2 } from '../../pipes/navigation-bar.pipe';
import { PathInstructionPipe } from '../../pipes/path-instruction.pipe';
import {
  NavigationRouteOverviewComponent,
  RouteOverviewNote,
  SpecificAreaDataCrate,
} from '../navigation-route-overview/navigation-route-overview.component';

@Component({
  selector: 'assist-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoPipe,
    ButtonComponent,
    IconComponent,
    LocalizedStringPipe,
    DirectionsItemRenewComponent,
    PathInstructionPipe,
    NavigationRouteOverviewComponent,
  ],
})
export class NavBarComponent implements OnInit {
  canShowStepNavigation: boolean;

  directionListResponse = input<FindPathResponseV2>();

  groupIdx = input.required<number>();

  navBarData = input<NavigationBarDataV2>();
  routeOverviewNotes = input<Record<number, RouteOverviewNote[]>>({});
  areaId = input<number>();
  isBarrierFreeRoute = input<boolean>();

  closeRoute = output<void>();
  requestRestartNavigation = output<void>();
  requestMoveToSpecificArea = output<SpecificAreaDataCrate>();

  directionItemClick = output<InstructionItem>();
  requestMoveToNextArea = output<void>();
  requestOpenTargetDetail = output<ResourcePoiIdentificationCrate>();

  navigationSettings = inject(NAVIGATION_SETTINGS);

  protected ICONS = {
    cueWheelchair,
    cueArrowFullRight,
    cueNavigationCircle,
    cueClose,
    cueElevator,
  };
  protected readonly translation = translation;
  // protected selectedDirectionItemIdx: number;

  ngOnInit() {
    this.canShowStepNavigation = this.navigationSettings.enableStepNavigation;
  }

  selectedDirectionItemIdx = model(-1);

  protected moveToNextArea() {
    this.requestMoveToNextArea.emit();
    this.selectedDirectionItemIdx.set(-1);
  }

  protected directionItemSelected(direction: InstructionItem, index: number) {
    this.selectedDirectionItemIdx.set(index);
    this.directionItemClick.emit(direction);
  }

  protected routeNoteNumber(areaIndex: number, instructionIndex: number): number | null {
    return (
      this.routeOverviewNotes()[areaIndex]?.find((note) => note.instructionIndex === instructionIndex)?.number ?? null
    );
  }

  protected openTargetDetail() {
    this.requestOpenTargetDetail.emit({
      qrCodeId: this.navBarData().targetGuid,
      resourceId: this.navBarData().targetResourceId,
      areaId:
        this.navBarData().areaList?.length > 0
          ? this.navBarData().areaList[this.navBarData().areaList.length - 1].areaId
          : null,
    });
  }
}
